import dayjs from "dayjs";

const formatAsListDate = (value) => {
  if (!value) return "";

  if (dayjs.isDayjs(value)) {
    return value.format("YYYY-MM-DD");
  }

  if (value instanceof Date) {
    return dayjs(value).format("YYYY-MM-DD");
  }

  const parsed = dayjs(value);
  return parsed.isValid() ? parsed.format("YYYY-MM-DD") : String(value);
};

export const formatCustomDateRangeLabel = (
  startDate,
  endDate,
  fallback = "Custom Date"
) => {
  const start = formatAsListDate(startDate);
  const end = formatAsListDate(endDate);

  if (start && end) return `${start} to ${end}`;
  return start || end || fallback;
};
